import * as types from './usersActionTypes';

export const getUserRequestAction = (payload) => ({
  type: types.GET_USER_REQUEST,
  payload,
});

export const getUserDataAction = (payload) => ({
  type: types.GET_USER_DATA,
  payload,
});

export const getUserErrorAction = (payload) => ({
  type: types.GET_USER_ERROR,
  payload,
});

export const sortUserHistorySortData = (payload) => ({
  type: types.SET_USER_HISTORY_SORT_DATA,
  payload,
});

export const sortingUserHistoryAction = (payload) => ({
  type: types.SORTING_USER_HISTORY_ACTION,
  payload,
});

export const createUserRequestAction = (payload) => ({
  type: types.CREATE_USER_REQUEST,
  payload,
});

export const createUserDataAction = (payload) => ({
  type: types.CREATE_USER_DATA,
  payload,
});

export const createUserErrorAction = (payload) => ({
  type: types.CREATE_USER_ERROR,
  payload,
});

export const updateUserRequestAction = (payload) => ({
  type: types.UPDATE_USER_REQUEST,
  payload,
});

export const updateUserDataAction = (payload) => ({
  type: types.UPDATE_USER_DATA,
  payload,
});

export const updateUserErrorAction = (payload) => ({
  type: types.UPDATE_USER_ERROR,
  payload,
});

export const deleteUserRequestAction = (payload) => ({
  type: types.DELETE_USER_REQUEST,
  payload,
});

export const deleteUserDataAction = (payload) => ({
  type: types.DELETE_USER_DATA,
  payload,
});

export const deleteUserErrorAction = (payload) => ({
  type: types.DELETE_USER_ERROR,
  payload,
});

// RESET PASSWORD Actions
export const resetUserPasswordRequestAction = (payload) => ({
  type: types.RESET_USER_PASSWORD_REQUEST,
  payload,
});

export const resetUserPasswordDataAction = (payload) => ({
  type: types.RESET_USER_PASSWORD_DATA,
  payload,
});

export const resetUserPasswordErrorAction = (payload) => ({
  type: types.RESET_USER_PASSWORD_ERROR,
  payload,
});

// CHANGE USER PASSWORD Actions
export const changeUserPasswordRequestAction = (payload) => ({
  type: types.CHANGE_USER_PASSWORD_REQUEST,
  payload,
});

export const changeUserPasswordDataAction = (payload) => ({
  type: types.CHANGE_USER_PASSWORD_DATA,
  payload,
});

export const changeUserPasswordErrorAction = (payload) => ({
  type: types.CHANGE_USER_PASSWORD_ERROR,
  payload,
});

// GET USER DETAILS Actions - Yeni eklenen
export const getUserDetailsRequestAction = (payload) => ({
  type: types.GET_USER_DETAILS_REQUEST,
  payload,
});

export const getUserDetailsDataAction = (payload) => ({
  type: types.GET_USER_DETAILS_DATA,
  payload,
});

export const getUserDetailsErrorAction = (payload) => ({
  type: types.GET_USER_DETAILS_ERROR,
  payload,
});